import { render, staticRenderFns } from "./LoginIpad.vue?vue&type=template&id=567e0f26"
import script from "./LoginIpad.vue?vue&type=script&lang=js"
export * from "./LoginIpad.vue?vue&type=script&lang=js"
import style0 from "./LoginIpad.vue?vue&type=style&index=0&id=567e0f26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports